import React from 'react';

interface MonthSelectorProps {
  currentMonth: string;
  viewMode: 'week' | 'month';
  isBusy: boolean;
  onPrevMonth: () => void;
  onNextMonth: () => void;
  onToggleView: () => void;
  onSwitchView: (mode: 'week' | 'month') => void;
}

const MonthSelector: React.FC<MonthSelectorProps> = ({
  currentMonth,
  viewMode,
  isBusy,
  onPrevMonth,
  onNextMonth,
  onToggleView,
  onSwitchView
}) => (
  <div className={`flex justify-between items-center gap-4 p-2 px-4 ${isBusy ? 'opacity-50 pointer-events-none' : ''}`}>
    <div className="flex items-center gap-4">
      <button
        onClick={onPrevMonth}
        className={`rounded-full p-2 border border-gray-300 shadow-md transition-all
          ${isBusy ? 'cursor-not-allowed bg-gray-100' : 'hover:bg-gray-100 active:bg-gray-200'}`}
        disabled={isBusy}
      >
        ◀
      </button>
      <button
        onClick={onToggleView}
        className={`font-semibold transition-all whitespace-nowrap ${isBusy ? 'cursor-not-allowed text-gray-500' : 'hover:text-gray-600'}`}
        disabled={isBusy}
      >
        {currentMonth}
      </button>
      <button
        onClick={onNextMonth}
        className={`rounded-full p-2 border border-gray-300 shadow-md transition-all
          ${isBusy ? 'cursor-not-allowed bg-gray-100' : 'hover:bg-gray-100 active:bg-gray-200'}`}
        disabled={isBusy}
      >
        ▶
      </button>
    </div>
    <div className="flex border border-gray-300 rounded overflow-hidden text-sm font-medium h-10">
      <button
        className={`px-4 text-base transition-all whitespace-nowrap
          ${viewMode === 'month' ? 'bg-gray-300' : 'bg-white'} 
          ${isBusy ? 'cursor-not-allowed opacity-50' : 'hover:bg-gray-200'}`}
        onClick={() => onSwitchView('month')}
        disabled={isBusy}
      >
        📅 Month
      </button>
      <button
        className={`px-4 text-base transition-all whitespace-nowrap
          ${viewMode === 'week' ? 'bg-gray-300' : 'bg-white'}
          ${isBusy ? 'cursor-not-allowed opacity-50' : 'hover:bg-gray-200'}`}
        onClick={() => onSwitchView('week')}
        disabled={isBusy}
      >
        📆 Week
      </button>
    </div>
  </div>
);

export default MonthSelector;
